"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M13.111 9.111C12.375 9.111 11.778 8.513 11.778 7.777C11.778 7.042 12.375 6.444 13.111 6.444C13.847 6.444 14.444 7.042 14.444 7.777C14.444 8.513 13.847 9.111 13.111 9.111ZM14.09 12.359C13.563 14.079 11.931 15.333 10 15.333C8.068 15.333 6.436 14.079 5.91 12.359C5.823 12.071 6.038 11.777 6.339 11.777H13.66C13.962 11.777 14.176 12.071 14.09 12.359ZM6.888 6.444C7.625 6.444 8.222 7.042 8.222 7.777C8.222 8.513 7.625 9.111 6.888 9.111C6.153 9.111 5.555 8.513 5.555 7.777C5.555 7.042 6.153 6.444 6.888 6.444ZM10 2C5.581 2 2 5.581 2 10C2 14.419 5.581 18 10 18C14.418 18 18 14.419 18 10C18 5.581 14.418 2 10 2Z",
    fill: "#727B7F"
  }));
};